/* eslint-disable react/jsx-no-useless-fragment */
import { Box } from '@mui/material';
import { useState } from 'react';
import CreateFeed from '../../../../components/feeds-component/Create';
import WelcomeBanner from '../../../../components/common/WelcomeBanner';
import Image from '../../../../fl-components/Image';

export default function BannerCumPoster() {
  const [hideBanner, setHideBanner] = useState(
    localStorage.getItem('displayBanner') ? localStorage.getItem('displayBanner') : false
  );
  return (
    <>
      {!hideBanner ? (
        <WelcomeBanner
          title="Welcome Back"
          description="If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything."
          action={() => {}}
          img={
            <Box
              width={{
                sm: '360px'
              }}
              margin={{
                sm: '0 auto'
              }}
            >
              <Image
                src="/static/illustrations/illustration_welcome.svg"
                sx={{
                  p: 2,
                  height: { sm: 250, xl: 300 },
                  span: {
                    display: 'flex !important',
                    alignItems: 'center !important'
                  }
                }}
                imageStyle={{ width: '100% !important', height: 'auto !important' }}
              />
            </Box>
          }
          onClose={() => setHideBanner(true)}
          showCloseBtn
        />
      ) : (
        <CreateFeed />
      )}
    </>
  );
}
